Bingo.RecalculatePrices = {};
Bingo.RecalculatePrices.update = function () {
    const priceSell = $('input[name=price_sell_proxy]').val().replace(/![0-9]|\s/g, '');
    Bingo.AutoNumeric.setVal($('input[name=price_final_proxy]'), Bingo.RecalculatePrices._calculateFinalPrice(priceSell, Bingo.RecalculatePrices.developerProjectDiscount));
};
Bingo.RecalculatePrices._calculateFinalPrice = function (price, discount) {
    price = (price === '') ? 0 : price;
    discount = (discount === '') ? 0 : discount;
    result = Math.round(price * (1 - (discount / 100)));
    return (result > 0) ? result : '';
};
Bingo.RecalculatePrices._numberFormat = function (str) {
    const strEl = `${str}`;
    const x = strEl.split('.');
    let x1 = x[0]; x2 = x.length > 1 ? `.${x[1]}` : '';
    const rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1,$2');
    }
    return `${x1 + x2}.00`;
};
